import { useState, useEffect, useContext, useRef } from "react";
import { surveyConfiguration } from "../../../api/automation/user_survey_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import DialogBox from "../../../components/dialog/dialog.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Option, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Dropdown, Card, Link, Input, Image, Accordion, AccordionItem, AccordionHeader, AccordionPanel, Tooltip, Skeleton, Spinner } from "@fluentui/react-components";
import { AddSquare20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, CalendarClock20Regular, Wand20Regular, SettingsCogMultiple20Regular, Filter20Filled, FilterDismiss20Filled, ArrowMaximize20Regular, DismissSquare24Filled, Delete20Regular, ArrowClockwise20Regular, ArrowDownload20Regular, Info24Filled, Open20Regular, Info20Filled, Dismiss16Regular, CheckmarkLock20Regular, AlertBadge20Regular, BrainCircuit20Regular, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Inputs } from "../../../components/textarea/input.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { fullscreenIcon, primaryIcon, exitIcon, deleteIcon, secondaryIcon, primaryWidth, secondaryWidth, accordionMargin, lightTheme, messageTheme, overflowDivider, buttonContent, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomationPages } from "../../../components/side_menu/InlineSidenav";

interface FormItem { id: number; data: {} }
interface FormItems { id: number; data: {} }

export const UserSurvey = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const dartNo: any = contextValue.dartNo;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isRefresh, setRefresh] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [surveyCounter, setSurveyCounter] = useState(2);
  const [selectedOption, setSelectedOption] = useState('');
  const [rowID, setRowID]: any = useState(null);
  const [automationOverLayData, setAutomationOverLayData]: any = useState([]);
  const [dartSpecs, setDartSpecs]: any = useState([]);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [saveTriggered, setSaveTriggered]: any = useState(false);
  const [deleteSurvey, setDeleteSurvey]: any = useState(false);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
  const [selectedAutomation, setSelectedAutomation] = useState('');
  const [automationStatus, setAutomationStatus] = useState('not attached');
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const { permissions } = usePermissionStore();
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);

  const [formData, setFormData]: any = useState({
    name: '',
    description: '',
    jsonData: ''
  });

  const [configFormData, setConfigFormData]: any = useState({
    surveyName: '',
    surveyid: '',
    greeting: '',
    header: '',
    SurveyTimeOutInMsec: '',
    SurveyIntervalInMsec: '',
    MaxTriesCount: '',
    questions: [],
    FinalMessage: ""
  });

  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);

  console.log("spinnerLoad",spinnerLoad)
  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => {
      return { key: item, label: <Caption1>{item}</Caption1>, };
    });
    setCreatedBy(createdByOptions);
    console.log("Created By Options:", createdByOptions);
  }, [uniqueCreatedBy]);

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  //clone code starts here
  const [cloneScore, setCloneScore] = useState<FormItems[]>([{
    id: 1,
    data: {
      answerid: 1,
      alabel: "",
      score: "",
      adesc: ""
    }
  }]);

  const [cloneForms, setCloneForms] = useState<FormItem[]>([{
    id: 1, data: {
      "questionid": 1,
      "qlabel": "",
      "type": "",
      "qdesc": "",
      "answer": [{
        answerid: 1,
        alabel: "",
        score: "",
        adesc: ""
      }]
    }
  }]);

  const handleAddAnswerClone = (ids: any, i: any) => {
    if (cloneScore.length < 5) {
      setCloneForms((prev: any) => [...prev.slice(0, i), {
        ...prev[i], data: {
          ...prev[i].data, answer: [...prev[i].data.answer, {
            answerid: ids,
            alabel: "",
            score: "",
            adesc: ""
          }]
        }
      }, ...prev.slice(i + 1)])
    }
  };

  const handleRemoveAnswerClone = (id: any, qid: any) => {
    var tempArr: any = [];

    cloneForms?.map((val: any) => {
      if (val.id == qid) {
        val.data.answer.filter((ele: any) => ele.answerid != id).map((value: any, i: any) => {
          tempArr.push({ ...value, answerid: i + 1 });
        })
      }
    });
    setCloneForms((prev: any) => [...prev.slice(0, qid - 1), { ...prev[qid - 1], data: { ...prev[qid - 1].data, answer: tempArr } }, ...prev.slice(qid)]);
  };

  const buttonref: any = useRef(null);
  const handleOutsideButton = () => { buttonref?.current?.click() };
  const handleSubmit = (e: any) => { e.preventDefault() }

  useEffect(() => {
    var flag = true;
    exportDetails.map((val: any) => {
      if (val.automationName === formData.name) {
        flag = false;
      }
    });

    if (overlayName === 'editSurvey' && formData.name === selectedAutomation) {
      flag = true;
    }

    setClassificationNameValidation(flag);
  }, [formData, selectedAutomation]);

  useEffect(() => {
    console.log("Clone Forms: ", cloneForms);
    setConfigFormData({ ...configFormData, questions: cloneForms?.map((val: any) => val.data) });
  }, [cloneForms]);

  useEffect(() => {
    console.log("Config Form Data: ", configFormData);
  }, [configFormData]);

  useEffect(() => {
    if (overlayName === 'addSurvey') {
      var name = formData.name;
      var id = name.split(" ").map((val: any) => val.charAt(0)).join("");
      setConfigFormData({ ...configFormData, surveyName: name, surveyid: id });
    }
    else if (overlayName === 'editSurvey') {
      var timeout = parseInt(formData.jsonData.SurveyTimeOutInMsec) / 60000;
      var interval = parseInt(formData.jsonData.SurveyIntervalInMsec) / 60000;
      setConfigFormData({ ...formData.jsonData, SurveyTimeOutInMsec: timeout.toString(), SurveyIntervalInMsec: interval.toString() });
      setCloneForms(formData.jsonData?.questions?.map((val: any, i: any) => { return { 'id': (i + 1), 'data': val } }))
    }
  }, [formData]);

  const handleAddClone = (ids: any) => {
    if (cloneForms.length < 5) {
      setCloneForms([...cloneForms, {
        id: ids, data: {
          "questionid": ids,
          "qlabel": "",
          "type": "",
          "qdesc": "",
          "answer": [{
            answerid: 1,
            alabel: "",
            score: "",
            adesc: ""
          }]
        }
      }]);
      setSurveyCounter(surveyCounter + 1);
      //setCloneForms([...cloneForms, { id: surveyCounter, data: {} }]);
    }
  };

  const handleRemoveClone = (id: any) => {
    var tempArr: any = [];
    cloneForms.filter((form) => form.id != id).map((val: any, i: any) => {
      tempArr.push({ ...val, id: i + 1, data: { ...val.data, questionid: i + 1 } });
    });
    setCloneForms(tempArr);
    setSurveyCounter(surveyCounter - 1);
  };

  const handleInput = (i: any, val: any, res: any) => {
    setCloneForms((prev: any) => [...prev.slice(0, i), { ...prev[i], data: { ...prev[i].data, [`${res}`]: val } }, ...prev.slice(i + 1)]);
  }

  const handleAnswerInput = (i: any, j: any, val: any, res: any) => {
    setCloneForms((prev: any) => [...prev.slice(0, i), { ...prev[i], data: { ...prev[i].data, answer: [...prev[i].data.answer.slice(0, j), { ...prev[i].data.answer[j], [`${res}`]: val }, ...prev[i].data.answer.slice(j + 1)] } }, ...prev.slice(i + 1)]);
  }

  const handle = useFullScreenHandle();

  const handleCloseFilter = (index: any): any => {
    console.log("Clicked...");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  useEffect(() => {
    if (filterArray.length > 0)
      setResetDisabled(false)
  }, [filterArray])
  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === ("Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Created by")) {
    //   if(regexS.test(enteredValue)){
    //     setDropDownValue2(enteredValue);
    //     }
    // }
  }

  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
  //   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
  //   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
  //   { key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
  //   { key: "status", label: <Body1Strong> Status </Body1Strong> }
  // ];
  //data table column name code ends here

  //data table for filter column starts here
  //   var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1> Description </Caption1> },
  //   { key: "created_by", label: <Caption1> Created by </Caption1> },
  //   { key: "created_on", label: <Caption1> Created On </Caption1> },
  //   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
  //   { key: "status", label: <Caption1> Status </Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Automation?.["User Survey"].forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.["User Survey"].filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Automation", page: "User Survey" });
  }, [contextValue.tableColumnsData]);


  // overflow set contents code starts here
  var overFlowComponent = {
    data: (
      <>
        {permissions.includes('all') || permissions.includes("automationUserSurveys_Fullaccess") ?

          <StackItem>
            <Button shape="circular"
              disabled={loading}
              size="small"
              appearance="subtle"
              onClick={() => {
                setOverlayOpen(true);
                setOverlayName('addSurvey');
                setOverlayOpen(true);
                setFormData({ name: '', description: '', jsonData: '' });
                setAutomationStatus('not attached');
                setConfigFormData({ surveyName: '', surveyid: '', greeting: '', header: '', questions: [] });
                setCloneForms([{ id: 1, data: { "questionid": 1, "qlabel": "", "type": "", "qdesc": "", "answer": [{ answerid: 1, alabel: "", score: "", adesc: "" }] } }]);
              }}
            >
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading ?
                  <AddSquare20Regular {...secondaryIcon} />
                  : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                <StackItem>
                  <Caption1>
                    Create Survey
                  </Caption1>
                </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem><Caption1>  Create Survey </Caption1></StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        }

        {/* <StackItem> <Button shape="circular" appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}> <Stack tokens={{childrenGap:5}} horizontal> <StackItem> <SaveCopy20Regular {...primaryIcon}/> </StackItem> <StackItem> <Caption1> Duplicate </Caption1> </StackItem> </Stack> </Button> </StackItem> */}

        <StackItem> <Divider vertical /> </StackItem>

        <StackItem>
          <DialogBox
            content="Are you sure you wish to remove the selected user survey ?"

            headerButton={
              <Button shape="circular"
                size="small"
                appearance="subtle"
                disabled={
                  isdeletedisabled
                    ? true
                    : false
                }
              >
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>
                    {isdeletedisabled
                      ? (<Delete20Regular {...secondaryIcon} />)
                      : (<Delete20Regular {...primaryIcon} />)
                    }
                  </StackItem>
                  <StackItem> <Caption1> Delete </Caption1> </StackItem>
                </Stack>
              </Button>
            }

            footer={
              <Stack horizontal tokens={{ childrenGap: 10 }}>
                <StackItem>
                  <Button shape="circular"
                    size="small"
                    appearance="primary"
                    onClick={() => {
                      setDeleteSurvey(true);
                      /*userActivity(
                        'Delete', 
                        `{
                          "summary":
                          "${contextValue.selectedRowIdInTable.length} 
                          ${contextValue.selectedRowIdInTable.length > 1 
                              ? 'automations' 
                              : 'automation'
                            } 
                          deleted"
                        }`
                      ); */
                    }}
                  >
                    Confirm
                  </Button>
                </StackItem>
                <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
              </Stack>
            }
          />
        </StackItem>

        <StackItem> <Divider vertical /> </StackItem>

        <StackItem>
          <Button shape="circular"
            disabled={loading}
            appearance="subtle"
            size="small"
            onClick={() => {
              setRefresh(true);
              setCurrentPageNo(1);
            }}
          >
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("automationUserSurveys_Fullaccess") || permissions.includes("automationUserSurveys_ReadandExport") ?

          <StackItem>
            <CSVLink data={exportData} id="csv-export-link" filename={`${tenantName}_usersurveylist.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true);/*userActivity('Export', `{"summary":"user survey automation list exported"}`)*/ }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                    <StackItem><Caption1>  Export </Caption1></StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        }

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ),
  };
  // overflow set contents code ends here

  var tempTableData: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status === 'not attached') {
        status = 'Not attached';
      }
      else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length === 0) {
          status = 'Enabled for other tenant';
        }
        else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus === 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length === 1
              ? `Enable for ${curStatus?.split(",").length} Device Classification`
              : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      if (val.status === 'not attached') {
        status = 'Not attached';
      }
      else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length === 0) {
          status = 'Enabled for other tenant';
        }
        else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus === 'all') {
            status = 'Enabled for All Devices';
          }
          else {
            status = curStatus?.split(",").length === 1
              ? `Enable for ${curStatus?.split(",").length} Device Classification`
              : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        'Name': val.automationName,
        'Description': val.description,
        'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
        'Created On': convertToExcelFormat(val.createdOn),
        'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
        'Status': status,
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];

      final_data?.forEach((val: any) => {
        if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
          newUniqueCreatedBy.push(val.createdBy);
        }
      });

      setUniqueCreatedBy(newUniqueCreatedBy);
      console.log("Unique Created By:", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    console.log("Final Data: ", final_data);

    var status = '';

    final_data !== undefined && final_data !== null ?
      final_data.map((val: any) => {
        if (val.status === 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length === 0) {
            status = 'Enabled for other tenant';
          }
          else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus === 'all') {
              status = 'Enabled for All Devices';
            }
            else {
              status = curStatus?.split(",").length === 1
                ? `Enable for ${curStatus?.split(",").length} Device Classification`
                : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }

        {
          permissions.includes('all') || permissions.includes("automationUserSurveys_Fullaccess") ?
            tempTableData.push({
              id: val.id,
              checkbox: status === 'Not attached' ? "show" : "hide",
              name: {
                label:
                  <Button
                    style={buttonContent}
                    id="ButtonHover"
                    appearance="transparent"
                    size="small"
                    onClick={() => {
                      setRowID(val.id);
                      val.status.includes(`${contextValue.tenantName}:`) ? setAutomationStatus('attached') : setAutomationStatus('not attached');
                      setOverlayOpen(true);
                      setOverlayName('editSurvey');
                      setSelectedAutomation(val.automationName);
                      setSpinnerLoad(true);
                    }}
                  >
                    {val.automationName}
                  </Button>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              name: {
                label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
                </Tooltip>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            });
        }
      })
      : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    if (saveBtnClicked) {
      setFormData({ ...formData, jsonData: configFormData });
      setSaveTriggered(true);
      setTimeout(() => {
        setSaveBtnClicked(false);
      }, 1000);
    } else {
      setSaveTriggered(false);
      setFormData({ name: '', description: '', jsonData: '' });
    }
  }, [saveBtnClicked]);

  useEffect(() => {
    if (dartSpecs?.length > 0) {
      var details = dartSpecs.length > 0 ? dartSpecs[0].details : "{}";
      details = JSON.parse(details);

      overlayName === 'addSurvey' && setAutomationOverLayData({
        size: "large",
        isTabs: true,
        headerTitle: <Title3> Create Survey  </Title3>,

        tabItems: {
          Introduction: (
            <form
              id="myFormUsersurvey"
              onSubmit={(e) => handleSubmit(e)}
            >
              <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                {/* <StackItem>
                  <FluentProvider theme={messageTheme}>
                    <Card appearance="subtle" size="small">
                      <Stack tokens={{childrenGap:10}} horizontal>
                        <StackItem> <Info20Filled {...primaryIcon}/> </StackItem>
                        <StackItem> <Caption1> These details will make it easy to find the snippets later when you need to use them. </Caption1> </StackItem>
                      </Stack>
                    </Card>
                  </FluentProvider>
                </StackItem> */}

                <StackItem> <Body1Strong> Name <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>

                {/* <Stack horizontal tokens={{childrenGap:550}}> */}
                <StackItem grow>
                  <p> <Inputs inputChange={setFormData} inputVal={formData} required={true} /></p>
                  {!classificationNameValidation && <Body1> This automation name already exists </Body1>}
                </StackItem>
                {/* <StackItem><Text></Text></StackItem> */}
                {/* </Stack> */}

                <StackItem> <Body1Strong> Survey Description </Body1Strong> </StackItem>

                <Resize
                  inputChange={setFormData}
                  inputValue={formData}
                />

                <InfoBar title={"These are the Basic details associated with this User Survey."} />

                {Object.keys(details).map(key => (
                  <>
                    <StackItem> <p> <Body1Strong> {key} </Body1Strong> </p> </StackItem>
                    <StackItem> <p> {details[key]} </p> </StackItem>
                  </>
                ))}
              </Stack>

              <Button shape="circular"
                ref={buttonref}
                type="submit"
                style={{ display: "none" }}
              >
                Validate
              </Button>
            </form>
          ),

          Configuration: (
            <form
              id="myFormUsersurvey"
              onSubmit={(e) => handleSubmit(e)}
            >
              <>
                {/* <Stack> <UserSurveyForm/> </Stack> */}
                <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> Greetings to be displayed to the User <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="11"
                            size="small"
                            required
                            value={configFormData.greeting}
                            onChange={(e) => { setConfigFormData({ ...configFormData, greeting: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>

                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> The need for the User Survey </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="12"
                            size="small"
                            value={configFormData.header}
                            onChange={(e) => { setConfigFormData({ ...configFormData, header: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>

                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> Survey timeout (in minutes) <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="13"
                            size="small"
                            required
                            type="number"
                            min={1}
                            value={configFormData.SurveyTimeOutInMsec}
                            onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyTimeOutInMsec: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>

                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> Time interval after which Survey should be retried <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="14"
                            size="small"
                            required
                            type="number"
                            min={1}
                            value={configFormData.SurveyIntervalInMsec}
                            onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyIntervalInMsec: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>

                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> Maximum Trials for the Survey  <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="15"
                            size="small"
                            required
                            type="number"
                            min={1}
                            value={configFormData.MaxTriesCount}
                            onChange={(e: any) => { setConfigFormData({ ...configFormData, MaxTriesCount: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>

                  <StackItem>
                    {cloneForms?.map((form: any, i: any) => (
                      <>
                        {/* {i != 0 && <Divider />} */}
                        <Stack horizontal key={form.id}>
                          <StackItem grow>
                            <Stack>
                              <StackItem>
                                <Stack>
                                  <StackItem>
                                    <Stack key={form.id} tokens={{ childrenGap: 10 }}>
                                      <StackItem>
                                        <Accordion style={accordionMargin}>
                                          <AccordionItem value="configuration_1">
                                            <AccordionHeader expandIconPosition='end'>
                                              <Stack tokens={{ childrenGap: 10 }}>
                                                <StackItem> <Body1Strong> Survey Question {i + 1} <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                    <Input
                                                      id={i}
                                                      size="small"
                                                      required
                                                      value={form.data.qdesc}
                                                      onChange={(e: any) => { handleInput(i, e.target.value, 'qdesc') }}
                                                      style={primaryWidth}
                                                    />
                                                    <StackItem>
                                                      {i == 0
                                                        ?
                                                        <Tooltip withArrow content="Add a New Question" relationship="label">
                                                          <Button shape="circular"
                                                            appearance="subtle"
                                                            aria-label="Close"
                                                            icon={<AddSquare20Regular {...primaryIcon} />}
                                                            onClick={() => { handleAddClone(cloneForms.length + 1) }}
                                                          />
                                                        </Tooltip>
                                                        :
                                                        <Tooltip withArrow content="Ignore this Question" relationship="label">
                                                          <Button shape="circular"
                                                            appearance="subtle"
                                                            aria-label="Close"
                                                            icon={<Delete20Regular {...deleteIcon} />}
                                                            onClick={() => handleRemoveClone(i + 1)}
                                                          />
                                                        </Tooltip>

                                                      }
                                                    </StackItem>
                                                  </Stack>
                                                </StackItem>
                                              </Stack>
                                            </AccordionHeader>

                                            <AccordionPanel>
                                              <Stack tokens={{ childrenGap: 10 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 10 }}>
                                                    <StackItem> <Body1Strong> Question Label </Body1Strong> </StackItem>
                                                    <Input
                                                      id={i}
                                                      size="small"
                                                      value={form.data.qlabel}
                                                      onChange={(e: any) => { handleInput(i, e.target.value, 'qlabel') }}
                                                      style={primaryWidth}
                                                    />
                                                  </Stack>
                                                </StackItem>

                                                <StackItem>
                                                  <Stack tokens={{ childrenGap: 10 }}>
                                                    <StackItem> <Body1Strong> Survey Answers <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                                    <StackItem>
                                                      <Dropdown
                                                        placeholder="Select"
                                                        defaultValue={form.data.type}
                                                        style={primaryWidth}
                                                      >
                                                        <Option
                                                          key={3}
                                                          value="Checkbox"
                                                          onClick={() => {
                                                            setSelectedOption("checkbox");
                                                            handleInput(i, "checkbox", 'type')
                                                          }}
                                                        >
                                                          Checkbox
                                                        </Option>

                                                        <Option
                                                          key={4}
                                                          value="Radio-button"
                                                          onClick={() => {
                                                            setSelectedOption("radio");
                                                            handleInput(i, "radio", 'type')
                                                          }}
                                                        >
                                                          Radio-button
                                                        </Option>
                                                      </Dropdown>
                                                    </StackItem>

                                                    <StackItem>
                                                      {form.data.answer.map((subform: any, j: any) => (
                                                        <Stack key={subform.id}>
                                                          {form.data.type != '' &&
                                                            <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                              <StackItem>
                                                                <Stack tokens={{ childrenGap: 10 }}>
                                                                  <StackItem> <Body1Strong> Answer label </Body1Strong> </StackItem>
                                                                  <Input
                                                                    id={j}
                                                                    size="small"
                                                                    value={subform.alabel}
                                                                    required
                                                                    onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'alabel') }}
                                                                    style={secondaryWidth}
                                                                  />
                                                                </Stack>
                                                              </StackItem>

                                                              <StackItem>
                                                                <Stack tokens={{ childrenGap: 10 }}>
                                                                  <StackItem> <Body1Strong> Score </Body1Strong> </StackItem>
                                                                  <Input
                                                                    id={j}
                                                                    size="small"
                                                                    value={subform.score}
                                                                    required
                                                                    onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'score') }}
                                                                    style={secondaryWidth}
                                                                  />
                                                                </Stack>
                                                              </StackItem>

                                                              <StackItem>
                                                                <Stack tokens={{ childrenGap: 10 }}>
                                                                  <StackItem> <Body1Strong> Answer description </Body1Strong> </StackItem>
                                                                  <Input
                                                                    id={j}
                                                                    size="small"
                                                                    value={subform.adesc}
                                                                    onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'adesc') }}
                                                                    style={secondaryWidth}
                                                                  />
                                                                </Stack>
                                                              </StackItem>

                                                              <StackItem>
                                                                {j == 0
                                                                  ?
                                                                  <Stack tokens={{ childrenGap: 20 }}>
                                                                    <StackItem><Text></Text></StackItem>
                                                                    <StackItem>
                                                                      <Button shape="circular"
                                                                        appearance="subtle"
                                                                        aria-label="Close"
                                                                        icon={<AddSquare20Regular {...primaryIcon} />}
                                                                        onClick={() => handleAddAnswerClone(form.data.answer.length + 1, i)}
                                                                      />
                                                                    </StackItem>
                                                                  </Stack>
                                                                  :
                                                                  <Stack tokens={{ childrenGap: 20 }}>
                                                                    <StackItem><Text></Text></StackItem>
                                                                    <StackItem>
                                                                      <Button shape="circular"
                                                                        appearance="subtle"
                                                                        aria-label="Close"
                                                                        icon={<Delete20Regular {...deleteIcon} />}
                                                                        onClick={() => handleRemoveAnswerClone(j + 1, i + 1)}
                                                                      />
                                                                    </StackItem>
                                                                  </Stack>
                                                                }
                                                              </StackItem>
                                                            </Stack>
                                                          }
                                                        </Stack>
                                                      ))}
                                                    </StackItem>
                                                  </Stack>
                                                </StackItem>
                                              </Stack>
                                            </AccordionPanel>
                                          </AccordionItem>
                                        </Accordion>
                                      </StackItem>
                                      <StackItem><Text></Text></StackItem>
                                    </Stack>
                                  </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          </StackItem>
                          {/* <StackItem> <Stack horizontal tokens={{childrenGap:20}}> <StackItem> <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular/>} onClick={() => handleRemoveClone(form.id)}/> </StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem> */}
                          <StackItem><Text></Text></StackItem>
                        </Stack>
                      </>
                    ))}
                  </StackItem>

                  <Stack tokens={{ childrenGap: 10 }}>
                    <StackItem> <Body1Strong> Final Message to be displayed after the Survey </Body1Strong> </StackItem>

                    <Stack horizontal tokens={{ childrenGap: 20 }}>
                      <StackItem grow>
                        <Stack>
                          <Input
                            id="16"
                            size="small"
                            value={configFormData.FinalMessage}
                            onChange={(e: any) => { setConfigFormData({ ...configFormData, FinalMessage: e.target.value }) }}
                            style={primaryWidth}
                          />
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>
                </Stack>
              </>
              <Button shape="circular"
                ref={buttonref}
                type="submit"
                style={{ display: "none" }}
              >
                Validate
              </Button>
            </form>
          ),


          "Review Data": (
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem> <Body1Strong> Survey Name </Body1Strong> </StackItem>

              <Stack horizontal tokens={{ childrenGap: 550 }}>
                <StackItem grow>
                  <Inputs
                    inputChange={setFormData}
                    inputVal={formData}
                    disabled={true}
                  />
                </StackItem>
                <StackItem><Text></Text></StackItem>
              </Stack>

              <StackItem> <Body1Strong> Survey Description </Body1Strong> </StackItem>

              <Resize
                inputChange={setFormData}
                inputValue={formData}
                disabled={true}
              />

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Greetings to be displayed to the User </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="11"
                        size="small"
                        disabled={true}
                        value={configFormData.greeting}
                        onChange={(e) => { setConfigFormData({ ...configFormData, greeting: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> The need for the User Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="12"
                        size="small"
                        disabled={true}
                        value={configFormData.header}
                        onChange={(e) => { setConfigFormData({ ...configFormData, header: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Survery Timeout (in minutes) </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="13"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyTimeOutInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyTimeOutInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Time interval after which survey should be retried </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="14"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyIntervalInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyIntervalInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Maximun Trials for the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="15"
                        size="small"
                        disabled={true}
                        value={configFormData.MaxTriesCount}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, MaxTriesCount: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <StackItem>
                {cloneForms?.map((form: any, i: any) => (
                  <>
                    {/* {i != 0 && <Divider />} */}
                    <Stack horizontal key={form.id}>
                      <StackItem grow>
                        <Stack>
                          <StackItem>
                            <Stack>
                              <StackItem>
                                <Stack key={form.id}>
                                  <StackItem>
                                    <Accordion collapsible style={accordionMargin}>
                                      <AccordionItem value="reviewData_1">
                                        <AccordionHeader expandIconPosition='end'>
                                          <Stack tokens={{ childrenGap: 10 }}>
                                            <StackItem> <Body1Strong> Survey Question {i + 1} </Body1Strong> </StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                <Input
                                                  id={i}
                                                  size="small"
                                                  disabled={true}
                                                  value={form.data.qdesc}
                                                  onChange={(e: any) => { handleInput(i, e.target.value, 'qdesc') }}
                                                  style={primaryWidth}
                                                />
                                              </Stack>
                                            </StackItem>
                                          </Stack>
                                        </AccordionHeader>

                                        <AccordionPanel>
                                          <Stack tokens={{ childrenGap: 10 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 10 }}>
                                                <StackItem> <Body1Strong> Question Label </Body1Strong> </StackItem>
                                                <Input
                                                  id={i}
                                                  size="small"
                                                  disabled={true}
                                                  value={form.data.qlabel}
                                                  onChange={(e: any) => { handleInput(i, e.target.value, 'qlabel') }}
                                                  style={primaryWidth}
                                                />
                                              </Stack>
                                            </StackItem>

                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 10 }}>
                                                <StackItem> <Body1Strong> Survey Answers <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                                <StackItem>
                                                  <Dropdown
                                                    placeholder="Select"
                                                    defaultValue={form.data.type}
                                                    disabled
                                                    style={primaryWidth}
                                                  />
                                                </StackItem>

                                                <StackItem>
                                                  {form.data.answer.map((subform: any, j: any) => (
                                                    <Stack key={subform.id}>
                                                      {form.data.type != '' &&
                                                        <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                          <StackItem>
                                                            <Stack tokens={{ childrenGap: 10 }}>
                                                              <StackItem> <Body1Strong> Answer label </Body1Strong> </StackItem>
                                                              <Input
                                                                id={j}
                                                                size="small"
                                                                disabled={true}
                                                                value={subform.alabel}
                                                                onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'alabel') }}
                                                                style={secondaryWidth}
                                                              />
                                                            </Stack>
                                                          </StackItem>

                                                          <StackItem>
                                                            <Stack tokens={{ childrenGap: 10 }}>
                                                              <StackItem> <Body1Strong> Score </Body1Strong> </StackItem>
                                                              <Input
                                                                id={j}
                                                                size="small"
                                                                disabled={true}
                                                                value={subform.score}
                                                                onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'score') }}
                                                                style={secondaryWidth}
                                                              />
                                                            </Stack>
                                                          </StackItem>

                                                          <StackItem>
                                                            <Stack tokens={{ childrenGap: 10 }}>
                                                              <StackItem> <Body1Strong> Answer description </Body1Strong> </StackItem>
                                                              <Input
                                                                id={j}
                                                                size="small"
                                                                disabled={true}
                                                                value={subform.adesc}
                                                                onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'adesc') }}
                                                                style={secondaryWidth}
                                                              />
                                                            </Stack>
                                                          </StackItem>
                                                        </Stack>
                                                      }
                                                    </Stack>
                                                  ))}
                                                </StackItem>
                                              </Stack>
                                            </StackItem>
                                          </Stack>
                                        </AccordionPanel>
                                      </AccordionItem>
                                    </Accordion>
                                  </StackItem>
                                  <StackItem><Text></Text></StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      </StackItem>
                    </Stack>
                  </>
                ))}
              </StackItem>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Final Message to be displayed after the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="16"
                        size="small"
                        disabled={true}
                        value={configFormData.FinalMessage}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, FinalMessage: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>
            </Stack>
          )
        },
      })

      overlayName === 'editSurvey' && automationStatus === 'not attached' && setAutomationOverLayData({
        size: "large",
        isTabs: true,
        headerTitle: <Title3> Edit {selectedAutomation} Survey </Title3>,

        tabItems: {
          Introduction: spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>:(
            <form
              id="myFormUsersurvey"
              onSubmit={(e) => handleSubmit(e)}
            >
              <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>

                <InfoBar title={" These details will make it easy to find the snippets later when you need to use them."} />

                <StackItem> <Body1Strong> Survey Name </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 550 }}>
                  <StackItem grow>
                    <Inputs
                      inputChange={setFormData}
                      inputVal={formData}
                    />

                    {!classificationNameValidation && <Body1> This automation name already exists </Body1>}
                  </StackItem>
                  <StackItem><Text></Text></StackItem>
                </Stack>

                <StackItem> <Body1Strong> Survey Description </Body1Strong> </StackItem>

                <Resize
                  inputChange={setFormData}
                  inputValue={formData}
                />
                <InfoBar title={"These are the Basic details associated with this User Survey."} />

                {Object.keys(details).map(key => (
                  <>
                    <StackItem> <p> <Body1Strong> {key} </Body1Strong> </p> </StackItem>
                    <StackItem> <p> {details[key]} </p> </StackItem>
                  </>
                ))}
              </Stack>
              <Button shape="circular"
                ref={buttonref}
                type="submit"
                style={{ display: "none" }}
              >
                Validate
              </Button>
            </form>
          ),

          Configuration: (
            <form
              id="myFormUsersurvey"
              onSubmit={(e) => handleSubmit(e)}
            >
              {/* <Stack> <UserSurveyForm/> </Stack> */}
              <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> Greetings to be displayed to the User </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="11"
                          size="small"
                          value={configFormData.greeting}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, greeting: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>

                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> The need for the User Survey </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="12"
                          size="small"
                          value={configFormData.header}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, header: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>

                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> Survery Timeout (in minutes) </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="13"
                          size="small"
                          type="number"
                          min={1}
                          value={configFormData.SurveyTimeOutInMsec}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyTimeOutInMsec: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>

                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> Time interval after which survey should be retried </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="14"
                          size="small"
                          type="number"
                          min={1}
                          value={configFormData.SurveyIntervalInMsec}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyIntervalInMsec: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>

                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> Maximun Trials for the Survey </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="15"
                          size="small"
                          type="number"
                          min={1}
                          value={configFormData.MaxTriesCount}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, MaxTriesCount: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>

                <StackItem>
                  {cloneForms?.map((form: any, i: any) => (
                    <>
                      {/* {i != 0 && <Divider />} */}
                      <Stack horizontal key={form.id}>
                        <StackItem grow>
                          <Stack>
                            <StackItem>
                              <Stack>
                                <StackItem>
                                  <Stack key={form.id}>
                                    <StackItem>
                                      <Accordion collapsible style={accordionMargin}>
                                        <AccordionItem value="configuration_2">
                                          <AccordionHeader expandIconPosition='end'>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem> <Body1Strong> Survey Question {i + 1} <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                  <Input
                                                    id={i}
                                                    size="small"
                                                    value={form.data.qdesc}
                                                    onChange={(e: any) => { handleInput(i, e.target.value, 'qdesc') }}
                                                    style={primaryWidth}
                                                  />
                                                  <StackItem>
                                                    {i == 0
                                                      ?
                                                      <Tooltip withArrow content="Add a New Question" relationship="label">
                                                        <Button shape="circular"
                                                          appearance="subtle"
                                                          aria-label="Close"
                                                          icon={<AddSquare20Regular {...primaryIcon} />}
                                                          onClick={() => { handleAddClone(cloneForms.length + 1) }}
                                                        />
                                                      </Tooltip>
                                                      :
                                                      <Tooltip withArrow content="Ignore this Question" relationship="label">
                                                        <Button shape="circular"
                                                          appearance="subtle"
                                                          aria-label="Close"
                                                          icon={<Delete20Regular {...deleteIcon} />}
                                                          onClick={() => handleRemoveClone(i + 1)}
                                                        />
                                                      </Tooltip>

                                                    }
                                                  </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </AccordionHeader>

                                          <AccordionPanel>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 10 }}>
                                                  <StackItem> <Body1Strong> Question Label </Body1Strong> </StackItem>
                                                  <Input
                                                    id={i}
                                                    size="small"
                                                    value={form.data.qlabel}
                                                    onChange={(e: any) => { handleInput(i, e.target.value, 'qlabel') }}
                                                    style={primaryWidth}
                                                  />
                                                </Stack>
                                              </StackItem>

                                              <StackItem>
                                                <Stack tokens={{ childrenGap: 10 }}>
                                                  <StackItem> <Body1Strong> Survey Answers <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                                  <StackItem>
                                                    <Dropdown
                                                      placeholder="Select"
                                                      defaultValue={form.data.type}
                                                      style={primaryWidth}
                                                    >
                                                      <Option
                                                        key={3}
                                                        value="Checkbox"
                                                        onClick={() => {
                                                          setSelectedOption("checkbox");
                                                          handleInput(i, "checkbox", 'type')
                                                        }}
                                                      >
                                                        Checkbox
                                                      </Option>

                                                      <Option
                                                        key={4}
                                                        value="Radio-button"
                                                        onClick={() => {
                                                          setSelectedOption("radio");
                                                          handleInput(i, "radio", 'type')
                                                        }}
                                                      >
                                                        Radio-button
                                                      </Option>
                                                    </Dropdown>
                                                  </StackItem>

                                                  <StackItem>
                                                    {form.data.answer.map((subform: any, j: any) => (
                                                      <Stack key={subform.id}>
                                                        {form.data.type != '' &&
                                                          <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                            <StackItem>
                                                              <Stack tokens={{ childrenGap: 10 }}>
                                                                <StackItem> <Body1Strong> Answer label </Body1Strong> </StackItem>
                                                                <Input
                                                                  id={j}
                                                                  size="small"
                                                                  value={subform.alabel}
                                                                  onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'alabel') }}
                                                                  style={secondaryWidth}
                                                                />
                                                              </Stack>
                                                            </StackItem>

                                                            <StackItem>
                                                              <Stack tokens={{ childrenGap: 10 }}>
                                                                <StackItem> <Body1Strong> Score </Body1Strong> </StackItem>
                                                                <Input
                                                                  id={j}
                                                                  size="small"
                                                                  value={subform.score}
                                                                  onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'score') }}
                                                                  style={secondaryWidth}
                                                                />
                                                              </Stack>
                                                            </StackItem>

                                                            <StackItem>
                                                              <Stack tokens={{ childrenGap: 10 }}>
                                                                <StackItem> <Body1Strong> Answer description </Body1Strong> </StackItem>
                                                                <Input
                                                                  id={j}
                                                                  size="small"
                                                                  value={subform.adesc}
                                                                  onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'adesc') }}
                                                                  style={secondaryWidth}
                                                                />
                                                              </Stack>
                                                            </StackItem>

                                                            <StackItem>
                                                              {j === 0
                                                                ?
                                                                <Stack tokens={{ childrenGap: 20 }}>
                                                                  <StackItem><Text></Text></StackItem>
                                                                  <StackItem>
                                                                    <Button shape="circular"
                                                                      appearance="subtle"
                                                                      aria-label="Close"
                                                                      icon={<AddSquare20Regular {...primaryIcon} />}
                                                                      onClick={() => handleAddAnswerClone(form.data.answer.length + 1, i)}
                                                                    />
                                                                  </StackItem>
                                                                </Stack>
                                                                :
                                                                <Stack tokens={{ childrenGap: 20 }}>
                                                                  <StackItem><Text></Text></StackItem>
                                                                  <StackItem>
                                                                    <Button shape="circular"
                                                                      appearance="subtle"
                                                                      aria-label="Close"
                                                                      icon={<Delete20Regular {...deleteIcon} />}
                                                                      onClick={() => handleRemoveAnswerClone(j + 1, i + 1)}
                                                                    />
                                                                  </StackItem>
                                                                </Stack>
                                                              }
                                                            </StackItem>
                                                          </Stack>
                                                        }
                                                      </Stack>
                                                    ))}
                                                  </StackItem>
                                                </Stack>
                                              </StackItem>
                                            </Stack>
                                          </AccordionPanel>
                                        </AccordionItem>
                                      </Accordion>
                                    </StackItem>
                                    <StackItem><Text></Text></StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </StackItem>
                        {/* <StackItem> <Stack horizontal tokens={{childrenGap:20}}> <StackItem> <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular/>} onClick={() => handleRemoveClone(form.id)}/> </StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem> */}
                        <StackItem><Text></Text></StackItem>
                      </Stack>
                    </>
                  ))}
                </StackItem>

                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem> <Body1Strong> Final Message to be displayed after the Survey </Body1Strong> </StackItem>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem grow>
                      <Stack>
                        <Input
                          id="16"
                          size="small"
                          value={configFormData.FinalMessage}
                          onChange={(e: any) => { setConfigFormData({ ...configFormData, FinalMessage: e.target.value }) }}
                          style={primaryWidth}
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>
              </Stack>
              <Button shape="circular"
                ref={buttonref}
                type="submit"
                style={{ display: "none" }}
              >
                Validate
              </Button>
            </form>
          ),

          "Review Data": (
            <Stack tokens={{ padding: "10px 0px" }}>
              <StackItem> <Body1Strong> Survey Name </Body1Strong> </StackItem>

              <Stack horizontal tokens={{ childrenGap: 550 }}>
                <StackItem grow>
                  <Inputs
                    inputChange={setFormData}
                    inputVal={formData}
                    disabled={true}
                  />
                </StackItem>
                <StackItem><Text></Text></StackItem>
              </Stack>

              <StackItem> <Body1Strong> Survey Description </Body1Strong> </StackItem>

              <Resize
                inputChange={setFormData}
                inputValue={formData}
                disabled={true}
              />

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Greetings to be displayed to the User </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="11"
                        size="small"
                        disabled={true}
                        value={configFormData.greeting}
                        onChange={(e) => { setConfigFormData({ ...configFormData, greeting: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> The need for the User Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="12"
                        size="small"
                        disabled={true}
                        value={configFormData.header}
                        onChange={(e) => { setConfigFormData({ ...configFormData, header: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Survery Timeout (in minutes) </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="13"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyTimeOutInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyTimeOutInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Time interval after which survey should be retried </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="14"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyIntervalInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyIntervalInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Maximun Trials for the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="15"
                        size="small"
                        disabled={true}
                        value={configFormData.MaxTriesCount}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, MaxTriesCount: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <StackItem>
                {cloneForms?.map((form: any, i: any) => (
                  <>
                    {/* {i != 0 && <Divider />} */}
                    <Stack horizontal key={form.id}>
                      <StackItem grow>
                        <Stack>
                          <StackItem>
                            <Stack>
                              <StackItem>
                                <Stack key={form.id}>
                                  <Accordion collapsible style={accordionMargin}>
                                    <AccordionItem value="reviewData_2">
                                      <AccordionHeader expandIconPosition='end'>
                                        <Stack tokens={{ childrenGap: 10 }}>
                                          <StackItem> <Body1Strong> Survey Question {i + 1} </Body1Strong> </StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                              <Input
                                                id={i}
                                                size="small"
                                                disabled={true}
                                                value={form.data.qdesc}
                                                onChange={(e: any) => { handleInput(i, e.target.value, 'qdesc') }}
                                                style={primaryWidth}
                                              />
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </AccordionHeader>

                                      <AccordionPanel>
                                        <Stack tokens={{ childrenGap: 10 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem> <Body1Strong> Question Label </Body1Strong> </StackItem>
                                              <Input
                                                id={i}
                                                size="small"
                                                disabled={true}
                                                value={form.data.qlabel}
                                                onChange={(e: any) => { handleInput(i, e.target.value, 'qlabel') }}
                                                style={primaryWidth}
                                              />
                                            </Stack>
                                          </StackItem>

                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem> <Body1Strong> Survey Answers <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                              <StackItem>
                                                <Dropdown
                                                  placeholder="Select"
                                                  defaultValue={form.data.type}
                                                  disabled
                                                  style={primaryWidth}
                                                />
                                              </StackItem>

                                              <StackItem>
                                                {form.data.answer.map((subform: any, j: any) => (
                                                  <Stack key={subform.id}>
                                                    {form.data.type != '' &&
                                                      <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Answer label </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.alabel}
                                                              onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'alabel') }}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>

                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Score </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.score}
                                                              onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'score') }}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>

                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Answer description </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.adesc}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>
                                                      </Stack>
                                                    }
                                                  </Stack>
                                                ))}
                                              </StackItem>
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </AccordionPanel>
                                    </AccordionItem>
                                  </Accordion>
                                </Stack>
                              </StackItem>
                              <StackItem><Text></Text></StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      </StackItem>
                    </Stack>
                  </>
                ))}
              </StackItem>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Final Message to be displayed after the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="16"
                        size="small"
                        disabled={true}
                        value={configFormData.FinalMessage}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, FinalMessage: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>
            </Stack>
          )
        },
      });

      overlayName === 'editSurvey' && automationStatus !== 'not attached' && setAutomationOverLayData({
        size: "large",
        isTabs: true,
        headerTitle: <Title3> {selectedAutomation} Survey </Title3>,
        tabItems: {
          Configuration3: spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>:(
            <Stack tokens={{ padding: "10px 0px" }}>
              <InfoBar showSpaces={false} title={"Editing is disabled for this automation as it is associated with a Tenant or Device Classification. To make changes, please detach it first."} />
              <StackItem> <Body1Strong> Survey Name </Body1Strong> </StackItem>

              <Stack horizontal tokens={{ childrenGap: 550 }}>
                <StackItem grow>
                  <Inputs
                    inputChange={setFormData}
                    inputVal={formData}
                    disabled={true}
                  />
                </StackItem>
                <StackItem><Text></Text></StackItem>
              </Stack>

              <StackItem> <Body1Strong> Survey Description </Body1Strong> </StackItem>

              <Resize
                inputChange={setFormData}
                inputValue={formData}
                disabled={true}
              />

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Greetings to be displayed to the User </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="11"
                        size="small"
                        disabled={true}
                        value={configFormData.greeting}
                        onChange={(e) => { setConfigFormData({ ...configFormData, greeting: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> The need for the User Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="12"
                        size="small"
                        disabled={true}
                        value={configFormData.header}
                        onChange={(e) => { setConfigFormData({ ...configFormData, header: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Survery Timeout (in minutes) </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="13"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyTimeOutInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyTimeOutInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Time interval after which survey should be retried </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="14"
                        size="small"
                        disabled={true}
                        value={configFormData.SurveyIntervalInMsec}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, SurveyIntervalInMsec: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Maximun Trials for the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="15"
                        size="small"
                        disabled={true}
                        value={configFormData.MaxTriesCount}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, MaxTriesCount: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>

              <StackItem>
                {cloneForms?.map((form: any, i: any) => (
                  <>
                    {/* {i != 0 && <Divider />} */}
                    <Stack horizontal key={form.id}>
                      <StackItem grow>
                        <Stack>
                          <StackItem>
                            <Stack>
                              <StackItem>
                                <Stack key={form.id}>
                                  <Accordion collapsible style={accordionMargin}>
                                    <AccordionItem value="reviewData_2">
                                      <AccordionHeader expandIconPosition='end'>
                                        <Stack tokens={{ childrenGap: 10 }}>
                                          <StackItem> <Body1Strong> Survey Question {i + 1} </Body1Strong> </StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                              <Input
                                                id={i}
                                                size="small"
                                                disabled={true}
                                                value={form.data.qdesc}
                                                onChange={(e: any) => { handleInput(i, e.target.value, 'qdesc') }}
                                                style={primaryWidth}
                                              />
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </AccordionHeader>

                                      <AccordionPanel>
                                        <Stack tokens={{ childrenGap: 10 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem> <Body1Strong> Question Label </Body1Strong> </StackItem>
                                              <Input
                                                id={i}
                                                size="small"
                                                disabled={true}
                                                value={form.data.qlabel}
                                                onChange={(e: any) => { handleInput(i, e.target.value, 'qlabel') }}
                                                style={primaryWidth}
                                              />
                                            </Stack>
                                          </StackItem>

                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 10 }}>
                                              <StackItem> <Body1Strong> Survey Answers <Image src="/Dashboard/image/required.svg" /> </Body1Strong> </StackItem>
                                              <StackItem>
                                                <Dropdown
                                                  placeholder="Select"
                                                  defaultValue={form.data.type}
                                                  disabled
                                                  style={primaryWidth}
                                                />
                                              </StackItem>

                                              <StackItem>
                                                {form.data.answer.map((subform: any, j: any) => (
                                                  <Stack key={subform.id}>
                                                    {form.data.type != '' &&
                                                      <Stack tokens={{ childrenGap: 20 }} horizontal>
                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Answer label </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.alabel}
                                                              onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'alabel') }}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>

                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Score </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.score}
                                                              onChange={(e: any) => { handleAnswerInput(i, j, e.target.value, 'score') }}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>

                                                        <StackItem>
                                                          <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem> <Body1Strong> Answer description </Body1Strong> </StackItem>
                                                            <Input
                                                              id={j}
                                                              size="small"
                                                              disabled={true}
                                                              value={subform.adesc}
                                                              style={secondaryWidth}
                                                            />
                                                          </Stack>
                                                        </StackItem>
                                                      </Stack>
                                                    }
                                                  </Stack>
                                                ))}
                                              </StackItem>
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </AccordionPanel>
                                    </AccordionItem>
                                  </Accordion>
                                </Stack>
                              </StackItem>
                              <StackItem><Text></Text></StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      </StackItem>
                    </Stack>
                  </>
                ))}
              </StackItem>

              <Stack tokens={{ childrenGap: 10 }}>
                <StackItem> <Body1Strong> Final Message to be displayed after the Survey </Body1Strong> </StackItem>

                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem grow>
                    <Stack>
                      <Input
                        id="16"
                        size="small"
                        disabled={true}
                        value={configFormData.FinalMessage}
                        onChange={(e: any) => { setConfigFormData({ ...configFormData, FinalMessage: e.target.value }) }}
                        style={primaryWidth}
                      />
                    </Stack>
                  </StackItem>
                </Stack>
              </Stack>
            </Stack>
          )
        },
      });
    }
  }, [dartSpecs, overlayName, cloneForms, cloneScore, formData, selectedOption, configFormData, classificationNameValidation]);

  useEffect(() => {
    !overlayOpen && setOverlayName('');
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0
      ? setDeleteDisabled(false)
      : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      tenant: tenantName,
      setExportBtnClicked: setExportBtnClicked,
      dartSpecs: dartSpecs,
      dartNo: dartNo,
      rowID: rowID,
      saveBtnClicked: saveBtnClicked,
      setSaveBtnClicked: setSaveBtnClicked,
      setOverlayOpen: setOverlayOpen,
      setExportDetails: setExportDetails,
      formData: formData,
      setFormData: setFormData,
      overlayName: overlayName,
      setErrorToast: setErrorToast,
      setToastMessage: setToastMessage,
      setIsToast: setIsToast,
      data: final_data,
      func: set_final_data,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      setDartSpecs: setDartSpecs,
      deleteSurvey: deleteSurvey,
      setDeleteSurvey: setDeleteSurvey,
      setDeleteDisabled: setDeleteDisabled,
      isRefresh: isRefresh,
      setRefresh: setRefresh,
      setRefreshToast: setRefreshToast,
      isFilter: isfilter,
      dropDownValue1: dropDownValue1,
      setIsFilter: setIsFilter,
      dropdownValue2: dropDownValue2,
      filterArray: filterArray,
      newData: formData,
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      setOverlayName: setOverlayName,
      setSaveTriggered: setSaveTriggered,
      exportBtnClicked: exportBtnClicked,
      setLoading: setLoading,
      setSpinnerLoad: setSpinnerLoad
    }

    if ((!saveBtnClicked && overlayName === '') || (!saveBtnClicked && overlayName === "editSurvey") || (saveTriggered && overlayName !== '')) {
      surveyConfiguration(props);
    }
  }, [deleteSurvey, isRefresh, searchVal, saveTriggered, rowID, currentPageNo, isfilter, filterArray, exportBtnClicked]);

  return (
    <FullScreen
      handle={handle}
      className="fullScreenBackgroundColor"
    >
      <StackItem grow shrink>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem grow shrink style={BreadcrumbsBorder}>
            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
              <StackItem><Text></Text></StackItem>
              <StackItem grow shrink>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
                      {name:"Automate", link: "/home" },
                      {name:"Automation", link:"/automate/automation/all_automations"},
                      {name:"User Surveys", link:"#"}
                    ]} 
                  /> </StackItem>
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </StackItem>
      <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
        <StackItem style={DynamicBoxingCSS}>
          {/* pages code starts here */}
          <Stack style={DynamicBoxingCSS} >
            <FluentProvider style={parentHome} theme={dashboardTheme}>
              <Stack style={parentHome} horizontal >
                {/* SPACING BETWEEN INLINE AND PAGE */}
                <SideMenu
                  leftOpenSubMenu={leftOpenSubMenu}
                  setleftOpenSubMenu={setleftOpenSubMenu}
                  menuItems={AutomationPages("User Surveys")}
                />
                <StackItem style={DynamicBoxingCSS}>
                  <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <OverflowSetCustomExample
                        overlayOpen={overlayOpen}
                        setOverlayOpen={setOverlayOpen}
                        component={overFlowComponent}
                      />
                      <Divider />
                    </StackItem>

                    <StackItem style={wraperStyle}>
                      <StackItem>
                        <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                          <Stack horizontal tokens={{ childrenGap: 10 }}>
                          <StackItem>
                            <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                            </StackItem>
                            <StackItem>
                              <MenuDropdown
                                open={filterMenuOpen}
                                btn={
                                  <MenuButton
                                    disabled={loading || tableData.length === 0}
                                    shape="circular"
                                    size="small"
                                    onClick={() => setFilterMenuOpen(true)}
                                  >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                }
                                itemVal={
                                  <>
                                    <Body1Strong> Add a Filter </Body1Strong>
                                    <Divider />
                                    <MenuList>
                                      <Stack tokens={{ childrenGap: 5 }}>
                                        <StackItem> <Text></Text> </StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>

                                        <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />

                                        <StackItem><Divider /></StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        {/* <DropdownComponent optionData={columns}/> */}

                                        {/* <Input 
                                        size='small' 
                                        name="filter" 
                                        onChange={inputChange} 
                                        value={dropDownValue2}
                                      /> */}
                                        {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                        {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                        <StackItem><Divider /></StackItem>
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                          <StackItem>
                                            <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                              disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                              <Caption1> Apply </Caption1>
                                            </Button>
                                          </StackItem>

                                          <StackItem>
                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                              <Caption1> Cancel </Caption1>
                                            </Button>
                                          </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>
                                }
                              />
                            </StackItem>

                            <StackItem
                              onClick={() => {
                                setFilterArray([]);
                                setIsFilter(false);
                                setDropDownValue2('');
                                setResetDisabled(true);
                              }}
                            >
                              <Button shape="circular"
                                size="small"
                                appearance="subtle"
                                disabled={isResetDisabled}
                              >
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                  <StackItem>
                                    {isResetDisabled
                                      ? (<FilterDismiss20Filled {...secondaryIcon} />)
                                      : (<FilterDismiss20Filled {...primaryIcon} />)
                                    }
                                  </StackItem>
                                  <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                </Stack>
                              </Button>
                            </StackItem>
                          </Stack>
                          {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                        </Stack>
                        <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                          <StackItem>
                            {filterArray.length > 0 && (
                              <Stack horizontal wrap>
                                {filterArray.map((item, index) => (
                                  <Button shape="circular" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </Button>
                                ))}
                              </Stack>
                            )}
                          </StackItem>

                          <StackItem disableShrink>
                            {(tableData.length > 0 && !loading) && (
                              totalRecords > 0 &&
                              <Caption1>
                                Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                              </Caption1>
                            )}
                          </StackItem>
                        </Stack>
                      </StackItem>
                      <InfoBar showSpaces={true} title={" Explore the Nanoheal Database for an in-depth understanding of this Automation Schedules. Learn more about its capabilities, features, and recommended practices to enhance your utilization of this automation solution within your ecosystem. "} />

                    </StackItem>

                    {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                  </Stack>
                </StackItem>
              </Stack>
            </FluentProvider>
          </Stack>

          <OverLay
            overlayopen={overlayOpen}
            setOverlayOpen={setOverlayOpen}
            overlayData={automationOverLayData}
            saveBtnFunc={setSaveBtnClicked}
            saveBtnClicked={saveBtnClicked}
            isNavBtn={automationStatus !== 'not attached' ? false : true}
            handleOutsideButton={handleOutsideButton}
            handleSubmit={handleSubmit}
            classificationNameValidation={classificationNameValidation}
          />

          {isToast &&
            <ToastComponent
              setmessagebar={setIsToast}
              isToastEnabled={isToast}
              toastIntent="success"
              position="top-end"
              title="Success"
              footer=""
              message={
                (!saveTriggered && overlayName === '')
                  ? "Automation Deleted Successfully"
                  : overlayName === 'addSurvey'
                    ? "New Automation Created Successfully"
                    : "Automation Edited Successfully"
              }
            />
          }

          {refreshToast &&
            <ToastComponent
              setmessagebar={setIsToast}
              isToastEnabled={refreshToast}
              toastIntent="success"
              position="top-end"
              title="Success"
              message={'Data Table Refreshed'}
              footer=""
            />
          }

          {errorToast &&
            <ToastComponent
              setmessagebar={setErrorToast}
              toastIntent="error"
              position="top-end"
              title="Failed"
              message={toastMessage}
              footer=""
            />
          }
        </StackItem>
        <StackItem><Text></Text></StackItem>
      </Stack>
    </FullScreen>
  );
};